import { NewsList } from '../types/news';
import moment from 'moment';

interface NewsCardProps {
  newsList: NewsList;
  newsListLoading: boolean;
}

export default function NewsCard({ newsList, newsListLoading }: NewsCardProps) {
  const formatTime = (time: string) => {
    return time ? moment(time).format('MM/DD/YYYY') : '';
  };

  return (
    <div className="news mt-6 px-4 sm:px-12 md:px-12">
      <div className="border border-gray-200 rounded-lg">
        <div className="border-b border-gray-200 p-4">
          <h2 className="text-sm sm:text-lg md:text-xl lg:text-2xl font-semibold">News</h2>
        </div>
        <div className="max-h-[475px] overflow-y-auto p-4 pt-0 pb-4">
          {newsListLoading ? (
            <div className="flex items-center justify-center h-[200px]">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#56b4e8]"></div>
            </div>
          ) : (
            <div className="space-y-3">
              {newsList.map((item) => (
                <div key={item.id} className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <img
                      src={item.thumbnailLink}
                      alt={item.headline}
                      className="w-[150px] h-[80px] object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm text-gray-500">
                      {formatTime(item.date)}
                    </div>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block mt-1 text-sm font-medium text-[#56b4e8] hover:text-[#56b4e8] truncate"
                    >
                      {item.headline}
                    </a>
                    <p className="mt-1 text-sm text-gray-500 line-clamp-2">
                      {item.summary}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
